// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ModalDialog_wrapper__3Yr3t"};